import React from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { UseFormWatch } from 'react-hook-form';
import { AddressSearchModal, HospitalModal } from '@/components/organisms';
import HospitalSearchModal from '@/components/organisms/HospitalSearchModal';
import type { Hospital, HospitalFormData } from '@/pages/main/hospital/types';
import type { TreatmentReportFormData } from '@/schemas/treatmentReportSchema';

interface TreatmentReportModalsProps {
  handleAddressSearchSelect: (result: any) => void;
  handleHospitalDelete: (hospital: Hospital) => void;
  handleHospitalSave: (data: HospitalFormData) => Promise<void>;
  handleHospitalSelect: (hospital: Hospital) => void;
  hospital?: Hospital;
  isAddressSearchModalOpen: boolean;
  isHospitalModalOpen: boolean;
  isHospitalSearchOpen: boolean;
  setIsAddressSearchModalOpen: Dispatch<SetStateAction<boolean>>;
  setIsHospitalModalOpen: Dispatch<SetStateAction<boolean>>;
  setIsHospitalSearchOpen: Dispatch<SetStateAction<boolean>>;
  watch: UseFormWatch<TreatmentReportFormData>;
}

export const TreatmentReportModals: React.FC<TreatmentReportModalsProps> = ({
  handleAddressSearchSelect,
  handleHospitalDelete,
  handleHospitalSave,
  handleHospitalSelect,
  hospital,
  isAddressSearchModalOpen,
  isHospitalModalOpen,
  isHospitalSearchOpen,
  setIsAddressSearchModalOpen,
  setIsHospitalModalOpen,
  setIsHospitalSearchOpen,
  watch,
}) => (
  <>
    <HospitalSearchModal
      isOpen={isHospitalSearchOpen}
      onClose={() => setIsHospitalSearchOpen(false)}
      onSelect={handleHospitalSelect}
      onDelete={handleHospitalDelete}
    />

    <HospitalModal
      isOpen={isHospitalModalOpen}
      isEdit={true}
      hospital={hospital ?? null}
      skipBlocker
      onClose={() => setIsHospitalModalOpen(false)}
      onSave={handleHospitalSave}
    />

    <AddressSearchModal
      isOpen={isAddressSearchModalOpen}
      onClose={() => setIsAddressSearchModalOpen(false)}
      onSelect={handleAddressSearchSelect}
      initialPostalCode1={watch('postal_code1') || ''}
      initialPostalCode2={watch('postal_code2') || ''}
      initialAddress={
        !(watch('postal_code1') || watch('postal_code2')) ? (watch('address') ?? '') : ''
      }
      addressType="patient"
      title="住所"
      initialActiveTab={
        watch('postal_code1') || watch('postal_code2') || (watch('address') || '').trim()
          ? 'search'
          : 'dropdown'
      }
    />
  </>
);

